import { systolicBloodPressurePk } from 'config.jsx';

class MeasureSelectionHelper {
  static combineBloodPressures(measureCodes) {
    const bloodPressure = {
      pk: -1,
      class_field: 'physiology',
      type: 'blood pressure',
      unit: 'mmHg',
      descript: 'Systolic and diastolic pressure',
      label: { orderNumber: '019', name: 'Blood pressure' },
    };
    const systolicBloodPressureIndex = measureCodes.map(measureCode => measureCode.pk)
      .indexOf(systolicBloodPressurePk);
    const bloodPressureMeasureCodes = measureCodes
      .splice(systolicBloodPressureIndex, 2, bloodPressure);
    return bloodPressureMeasureCodes;
  }

  static addBloodPressureMeasureCodes(selectedMeasureCodes, bloodPressureMeasureCodes) {
    const combinedBloodPressureIndex = selectedMeasureCodes
      .map(measureCode => measureCode.pk).indexOf(-1);
    const filteredMeasureCodes = selectedMeasureCodes.length < 2
      ? bloodPressureMeasureCodes
      : combinedBloodPressureIndex === 0
        ? [...bloodPressureMeasureCodes, selectedMeasureCodes[1]]
        : [selectedMeasureCodes[0], ...bloodPressureMeasureCodes];
    const measureCodesWithNewAxisIndex = [filteredMeasureCodes, 2 - combinedBloodPressureIndex];
    return measureCodesWithNewAxisIndex;
  }

  static addBloodCellCombination(measureCodes) {
    const whiteBloodCellCombination = {
      pk: -2,
      class_field: 'immunology',
      type: 'white blood cells',
      unit: 'unit',
      descript: 'White blood cells combined',
      label: { orderNumber: '000', name: 'White blood cells' },
    };
    measureCodes.push(whiteBloodCellCombination);
  }
}

export default MeasureSelectionHelper;



// WEBPACK FOOTER //
// ./src/components/health-graph/MeasureSelectionHelper.jsx